<template>
  <ResponsiveModal
    :title="$t('components.asset_groups.create.title')"
    :description="$t('components.asset_groups.create.description')"
    :confirmLabel="$t('components.buttons.save')"
    :withClose="false"
    variant="create"
    alignButtons="center"
    :disableConfirm="!(isDirty || !isEmpty(names))"
    @confirm="handleAddAssetGroup"
    @update:open="reset"
  >
    <slot />
    <template #content>
      <div class="flex flex-col items-center p-4">
        <span v-if="maxSmall">
          {{ $t("components.asset_groups.create.description") }}
        </span>
      </div>
      <div class="flex flex-col grow md:max-w-[550px] border-t">
        <div class="flex flex-col grow py-4 px-5 md:px-3 bg-secondary">
          <GroupsInput
            as="textarea"
            :placeholder="
              $t('components.asset_groups.create.form.name.placeholder')
            "
            v-model="names"
            variant="asset_group"
            @update:isDirty="isDirty = $event"
          />
        </div>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref, nextTick, inject } from "vue";
import { isEmpty } from "lodash";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { GroupsInput } from "@/SharedComponents/Inputs";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { useAssetGroups } from "@/Composables/useAssetGroups";

// Breakpoints
const { maxSmall } = useBreakpoints();

// Emitter
const emitter = inject("emitter");

// Define Props
const props = defineProps({
  item: { type: Object, required: false },
});

// Refs
const names = ref([]);
const { addAssetGroup } = useAssetGroups();
const isDirty = ref(false);

// Functions
const handleAddAssetGroup = () => {
  addAssetGroup(
    names.value,
    props.item
      ? props.item.value
        ? props.item.value.id
        : props.item.id
      : null,
    () => {
      emitter.emit("reload-asset-groups");
    }
  );
};

const reset = () => {
  nextTick(() => {
    names.value = [];
  });
};
</script>
